import { render, staticRenderFns } from "./registrationDialog.vue?vue&type=template&id=0629d516&scoped=true"
import script from "./registrationDialog.vue?vue&type=script&lang=js"
export * from "./registrationDialog.vue?vue&type=script&lang=js"
import style0 from "./registrationDialog.vue?vue&type=style&index=0&id=0629d516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0629d516",
  null
  
)

export default component.exports